export { default } from './CommentForm';



// WEBPACK FOOTER //
// ./src/components/Comment/CommentForm/index.js